import { historyTimeline } from "@/mocks/homeContent";

const stateCfg: Record<string, { label: string; cls: string; icon: string }> = {
  latest: { label: "最新版", cls: "bg-primary-500 text-background-50", icon: "ri-rocket-2-fill" },
  online: { label: "在线", cls: "bg-accent-100 text-accent-800", icon: "ri-checkbox-circle-line" },
  archived: { label: "已归档", cls: "bg-background-200 text-foreground-600", icon: "ri-archive-line" },
  offline: { label: "已下线", cls: "bg-background-200 text-foreground-600", icon: "ri-close-circle-line" },
};

function HistoryTimeline() {
  return (
    <section id="timeline" className="scroll-mt-24 bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <div className="flex flex-col gap-10 lg:flex-row lg:items-start">
          <div className="shrink-0 lg:w-[360px]">
            <div className="flex flex-col items-start">
              <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-50 px-3 py-1 text-xs font-semibold text-primary-700 ring-1 ring-primary-200">
                <i className="ri-history-line"></i>
                发布历史
              </span>
              <h2 className="mt-4 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
                吃瓜地址发布历史
              </h2>
              <p className="mt-3 text-sm leading-6 text-foreground-600">
                按时间顺序完整记录每一次换新地址与版本发布。每一行代表一个可回溯的节点，
                最新换新地址已标注，往期入口可在右侧定位对应版本号。
              </p>
              <div className="mt-6 flex flex-wrap gap-3 text-xs text-foreground-600">
                <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-100 px-2.5 py-1 text-accent-800">
                  <span className="h-1.5 w-1.5 rounded-full bg-accent-600"></span>
                  当前在网
                </span>
                <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-200 px-2.5 py-1 text-foreground-600">
                  <i className="ri-archive-line"></i>
                  可归档回溯
                </span>
              </div>
            </div>
          </div>

          {/* timeline list */}
          <div className="relative flex-1 pl-6 md:pl-8">
            <span
              className="absolute left-[9px] top-2 bottom-2 w-px bg-background-300 md:left-[13px]"
              aria-hidden="true"
            ></span>
            <ul className="space-y-5">
              {historyTimeline.map((item) => {
                const cfg = stateCfg[item.state];
                return (
                  <li key={item.id} className="relative">
                    <span
                      className={`absolute -left-6 top-2 flex h-5 w-5 items-center justify-center rounded-full ring-4 ring-background-100 md:-left-8 md:h-7 md:w-7 ${
                        item.state === "latest"
                          ? "bg-primary-500"
                          : item.state === "online"
                          ? "bg-accent-500"
                          : "bg-background-300"
                      }`}
                      aria-hidden="true"
                    ></span>
                    <div className="rounded-xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-200 md:p-5">
                      <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
                        <span className="font-heading text-sm font-bold text-primary-600">
                          {item.version}
                        </span>
                        <span
                          className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-semibold ${cfg.cls}`}
                        >
                          <i className={`${cfg.icon} text-[11px]`}></i>
                          {cfg.label}
                        </span>
                        <span className="ml-auto inline-flex items-center gap-1 whitespace-nowrap text-xs text-foreground-500">
                          <i className="ri-calendar-line"></i>
                          {item.date}
                        </span>
                      </div>
                      <h3 className="mt-2.5 font-heading text-base font-bold text-foreground-950">
                        {item.title}
                      </h3>
                      <p className="mt-1 text-sm leading-6 text-foreground-600">{item.summary}</p>
                      {item.url && (
                        <p className="mt-2 inline-flex items-center gap-1.5 rounded-md bg-background-100 px-2 py-1 font-heading text-xs font-semibold text-foreground-700">
                          <i className="ri-link"></i>
                          {item.url}
                        </p>
                      )}
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HistoryTimeline;